import { Subject } from 'rxjs'

class IconLink{
    constructor(svgEl) {
        this._svgEl = svgEl;
        this._el = null;
        this._onClick = null;
    }
    get onClick(){
        if(this._onClick==null){
            this._onClick = new Subject();
        }
        return this._onClick;
    }
    get svgEl(){
        return this._svgEl;
    }
    get el() {
        if (this._el == null) {
            let el = document.createElement('a');
            el.classList.add('icon-link');
            el.appendChild(this.svgEl);
            el.addEventListener('click',this.handleClick.bind(this));
            this._el = el;
        }
        return this._el;
    }
    handleClick(e){
        this.onClick.next(e);
    }
}

export { IconLink }